
import { IconButton } from "@mui/material"
import { sparePartColNm } from "./constant"
import { ArticleRounded } from "resource/muiImport"
import { numberFormat } from "utils"

export const sparePartColumns = [
  {
    field: 'ShowDetail',
    headerName: '',
    width: 40,
    align: 'center',
    renderCell: () => (
      <IconButton size="small">
        <ArticleRounded color="primary" />
      </IconButton>
    )
  },
  {
    field: "No",
    headerName: "No.",
    width: 50,
    align: 'center',
  },
  {
    field: "SpCd",
    headerName: sparePartColNm.SpCd,
    width: 120,
  },
  {
    field: "SpNm",
    headerName: sparePartColNm.SpNm,
    width: 200,
  },
  {
    field: "SpSNm",
    headerName: sparePartColNm.SpSNm,
    width: 100,
  },
  {
    field: "SpTypNm",
    headerName: sparePartColNm.SpTypId,
    width: 120,
  },
  {
    field: "Brand",
    headerName: sparePartColNm.Brand,
    width: 100,
  },
  {
    field: "Model",
    headerName: sparePartColNm.Model,
    width: 100,
  },
  {
    field: "Unt",
    headerName: sparePartColNm.Unt,
    width: 70,
  },
  {
    field: "UntPr",
    headerName: sparePartColNm.UntPr,
    width: 100,
    align: "right",
    valueFormatter: ({ value }) => value ? numberFormat(value) : "-",
  },
  {
    field: "MinStk",
    headerName: sparePartColNm.MinStk,
    width: 80,
    align: "right",
  },
  {
    field: "CurStk",
    headerName: sparePartColNm.CurStk,
    width: 80,
    align: "right",
  },
  {
    field: "Dscp",
    headerName: sparePartColNm.Dscp,
    flex: 1,
    minWidth: 120,
  },
  {
    field: "Rmk",
    headerName: sparePartColNm.Rmk,
    width: 120,
  },
]
